import React, { ReactNode } from 'react';

import customerFormSchema, { CustomerFormSchema } from 'core/schemas/customerForm';
import { Form, FormSubmitHandler } from 'Elements/Form';

type Props = {
  onSubmit: FormSubmitHandler<CustomerFormSchema>;
  customer?: CustomerFormSchema['customer'];
  children: ReactNode;
  id?: number;
};

export default function CustomerForm({
  onSubmit,
  customer,
  children,
  id
}: Props) {
  return (
    <Form
      validationSchema={customerFormSchema.meta({ customerId: id })}
      onSubmit={onSubmit}
      initialValues={{ customer }}
    >
      {children}
    </Form>
  );
}
